const rootPath = process.env.VUE_APP_ARGON_MULTI_ORG === 'true' ? '/:orgRef/flows' : '/flows'

export default [
  {
    path: rootPath,
    component: () => import('@argon/app/components/AppLayout'),
    props: { nav: 'organizations' },
    children: [
      {
        path: '',
        name: 'flows',
        component: () => import('./views/Flows'),
        props: true,
        meta: {
          perimeterAction: 'read'
        },
        children: [
          {
            path: 'new',
            name: 'newFlow',
            props: true,
            component: () => import('./views/ModalNewFlow'),
            meta: {
              perimeterAction: 'read'
            }
          },
          {
            path: 'restore',
            name: 'flowRestore',
            props: true,
            component: () => import('./views/ModalFlowRestore'),
            meta: {
              perimeterAction: 'read'
            }
          }
        ]
      },
      {
        path: ':flowId',
        name: 'flow',
        component: () => import('./views/Flow'),
        props: true,
        meta: {
          perimeterAction: 'read'
        },
        children: [
          {
            path: 'properties',
            name: 'flowProperties',
            props: true,
            component: () => import('./views/ModalProperties'),
            meta: {
              perimeterAction: 'read'
            }
          },
          {
            path: 'states/:stateName',
            name: 'flowState',
            props: true,
            component: () => import('./views/FlowStateModal'),
            meta: {
              perimeterAction: 'read'
            },
            children: [
              {
                path: 'transitions/:transitionName/:ingress',
                name: 'flowTransition',
                props: true,
                component: () => import('./views/FlowTransitionModal'),
                meta: {
                  perimeterAction: 'read'
                },
                children: [
                  {
                    path: 'actions/:actionName',
                    name: 'nestedFlowAction',
                    props: true,
                    component: () => import('./views/FlowActionModal'),
                    meta: {
                      perimeterAction: 'read'
                    }
                  }
                ]
              }
            ]
          },
          {
            path: 'actions',
            name: 'flowActionList',
            props: true,
            component: () => import('./views/FlowActionsListModal'),
            meta: {
              perimeterAction: 'read'
            },
            children: [
              {
                path: ':actionName',
                name: 'flowAction',
                props: true,
                component: () => import('./views/FlowActionModal'),
                meta: {
                  perimeterAction: 'read'
                }
              }
            ]
          }
        ]
      }
    ]
  }
]
